import * as React from 'react';

import {Button} from 'shells/button/button';
import {Dialog} from 'shells/dialog/dialog';
import {FlashBanner} from 'shells/flash-banner/flash-banner';

import styles from './unschedule-banner.module.css';

type Props = {
    userFacingNoun: string;
    onUnschedule: () => Promise<any>;
};

export function UnscheduleBanner(props: Props) {
    const [isShowingUnscheduleConfirmation, setIsShowingUnscheduleConfirmation] =
        React.useState<boolean>(false);
    const [unscheduleButtonRef, setUnscheduleButtonRef] = React.useState<
        HTMLElement | null | undefined
    >(null);

    return (
        <>
            <FlashBanner type='info' hasBorder={true} noRightPadding={true}>
                <div className='flex justify-sb full-width'>
                    Unschedule this message to edit
                    <Button
                        variant='text-primary'
                        size='big'
                        onClick={() => setIsShowingUnscheduleConfirmation(true)}
                        getButtonRef={setUnscheduleButtonRef}
                        className={styles['unschedule-button']}
                    >
                        Unschedule
                    </Button>
                </div>
            </FlashBanner>
            {isShowingUnscheduleConfirmation ? (
                <Dialog
                    anchor={unscheduleButtonRef}
                    question={`This ${props.userFacingNoun} will no longer be scheduled to send. Are you sure?`}
                    primaryText='Yes, unschedule'
                    isWarning={true}
                    onPrimary={() => {
                        if (props.onUnschedule) {
                            props.onUnschedule().then(() => {
                                setIsShowingUnscheduleConfirmation(false);
                            });
                        }
                    }}
                    secondaryText='No, keep scheduling'
                    onSecondary={() => {
                        setIsShowingUnscheduleConfirmation(false);
                    }}
                />
            ) : undefined}
        </>
    );
}
